<ion-header class="ion-no-border" *ngIf="showHeader">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button
        defaultHref="/call/dashboard"
        text=""
        icon="chevron-back"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>Services</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [style.display]="contentDisplayType" *ngIf="showHeader">
  <form class="form" [formGroup]="formReserv" *ngIf="sameRestaurant">
    <ion-row>
      <ion-col width-50>
        <ion-item>
          <ion-label position="floating">Client</ion-label>
          <ion-input
            type="text"
            formControlName="nome"
            [attr.readonly]="
              this.sameRestaurant || (claim === userType.Passenger && !isQrCode)
            "
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col width-50>
        <ion-item>
          <ion-label position="floating">Cell Phone</ion-label>
          <ion-input
            type="tel"
            formControlName="celular"
            [attr.readonly]="
              this.sameRestaurant || (claim === userType.Passenger && !isQrCode)
            "
          ></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <div>
      <app-kitchen-types
        #kitchen
        *ngIf="claim === userType.Caller || claim === userType.Passenger"
        (emitterKitchenSelected)="eventKitchenSelected($event)"
      ></app-kitchen-types>
      <div
        *ngIf="
          (restaurants.length && claim === userType.Caller) ||
          claim === userType.Passenger
        "
        class="restaurants-list"
      >
        <ion-label position="floating">Establishment</ion-label>
        <swiper-container
          #restaurantSlides
          class="list"
          pager="true"
          [options]="slideOpts"
          [slidesPerView]="2"
          *ngIf="restaurants.length"
          (swiperinit)="initSwiper($fsd)"
        >
          <swiper-slide
            *ngFor="let restaurant of restaurants"
            [ngClass]="{
              active: formReserv.get('restaurante').value === restaurant.id,
            }"
            (click)="selectedRestaurant(restaurant)"
          >
            <ion-card
              class="block"
              style="background-color: initial"
              [ngClass]="{
                active:
                  chosenRestaurant &&
                  restaurant &&
                  chosenRestaurant?.id === restaurant.id,
              }"
            >
              <ion-card-header>
                <img
                  [lazyLoad]="restaurant.icone"
                  [defaultImage]="'assets/icons/default.png'"
                  [errorImage]="'assets/icons/default.png'"
                  class="icon"
                />
                <ion-card-subtitle>{{
                  restaurant.nomeRestaurante
                }}</ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <div class="price">{{ restaurant.preco }}</div>
                <small>
                  <ion-icon name="pin"></ion-icon> {{ restaurant.endereco }}
                </small>
              </ion-card-content>
            </ion-card>
          </swiper-slide>
        </swiper-container>
      </div>
      <ion-row
        *ngIf="
          (claim === userType.Caller || claim === userType.Passenger) &&
          chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
        "
      >
        <ion-col width-33>
          <ion-item>
            <ion-label position="floating">Language</ion-label>
            <ion-select [value]="language" multiple formControlName="idiomas">
              <ion-select-option
                *ngFor="let language of languagesAvailable()"
                [value]="language.value"
                [disabled]="checkValue(language)"
              >
                {{ language.label }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col
          width-33
          *ngIf="
            chosenRestaurant &&
            chosenRestaurant.tipoComissao &&
            chosenRestaurant.tipoComissao != 'COMISSAO_FIXA'
          "
        >
          <ion-item>
            <ion-label position="floating">N° People</ion-label>
            <ion-input
              (change)="calculateValue()"
              formControlName="quantidade-pessoas"
              type="number"
              max="30"
              min="0"
            >
            </ion-input>
          </ion-item>
        </ion-col>
        <ion-col width-33>
          <ion-item>
            <ion-label position="floating">Service</ion-label>
            <ion-select
              [value]="service"
              multiple
              formControlName="servicos"
              placeholder="Select a service"
            >
              <ion-select-option
                *ngFor="let service of servicesAvailable()"
                [value]="service.value"
              >
                {{ service.label }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
      <div
        class="block-check"
        *ngIf="
          claim != userType.Restaurant &&
          chosenRestaurant?.aceitaReservasTipoWalkin &&
          chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
        "
      >
        <ion-label
          *ngIf="
            chosenRestaurant?.aceitaReservasTipoWalkin &&
            !chosenRestaurant?.aceitaReservasAgendadas
          "
        >
          Note: Walk-ins only</ion-label
        >
        <ion-checkbox
          slot="end"
          (ionChange)="setWalkIn()"
          formControlName="walkIn"
        ></ion-checkbox>
        <ion-label><strong>Walk-in</strong></ion-label>
      </div>
      <ion-row
        *ngIf="
          claim === userType.Restaurant &&
          chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
        "
      >
        <ion-col>
          <ion-item>
            <ion-label position="floating">N° People</ion-label>
            <ion-input
              (change)="calculateValue()"
              formControlName="quantidade-pessoas"
              type="number"
              max="30"
              min="0"
            >
            </ion-input>
          </ion-item>
        </ion-col>
        <ion-col *ngIf="chosenRestaurant?.aceitaReservasTipoWalkin">
          <div class="block-check block-check2">
            <ion-label *ngIf="chosenRestaurant?.aceitaReservasTipoWalkin"
              >Note: Walk-ins only</ion-label
            >
            <ion-checkbox
              slot="end"
              (ionChange)="setWalkIn()"
              formControlName="walkIn"
            ></ion-checkbox>
            <ion-label><strong>Walk-in</strong></ion-label>
          </div>
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="!walkIn && chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'"
      >
        <ion-col width-100>
          <div
            class="calendar"
            *ngIf="
              formReserv.get('restaurante').value &&
              chosenRestaurant?.aceitaReservasAgendadas
            "
          >
            <ion-label>Reservation Date</ion-label>
            <div class="datepicker-form">
              <p (click)="openCalendarScheduled()">
                {{
                  selectedDate
                    ? (dateControl.value
                      | date
                        : "yyyy/MM/dd
                hh:mm a")
                    : "Select a date"
                }}
              </p>
              <ion-label
                position="floating"
                style="margin-bottom: 10px; margin-left: 5px"
              >
                <ion-icon name="calendar-outline"></ion-icon>
              </ion-label>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <div
        class="value-payment"
        *ngIf="
          formReserv.get('valor').value > 0 &&
          claim === userType.Caller &&
          chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
        "
      >
        <p>Amount payable:</p>
        <h2 class="value">{{ formReserv.get("valor").value | currency }}</h2>
      </div>
      <div
        class="value-payment"
        *ngIf="
          claim === userType.Caller &&
          chosenRestaurant?.tipoEstabelecimento == 'BROCHURE'
        "
      >
        <p>Points:</p>
        <h2 class="value">{{ chosenRestaurant?.pontuacao }}</h2>
      </div>
      <div class="comment-box" *ngIf="formReserv.get('observation').value">
        <ion-label position="floating">Comment</ion-label>
        <div class="block">
          <ion-icon name="chatbubbles"></ion-icon>
          {{ formReserv.get("observation").value }}
        </div>
      </div>
      <footer class="ion-padding-top ion-padding-bottom">
        <!-- <ion-button
          *ngIf="claim === userType.Caller"
          (click)="sendRequest()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
        <ion-button
          *ngIf="claim === userType.Passenger"
          (click)="sendRequestClient()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button> -->
        <ion-button
          *ngIf="claim === userType.Restaurant"
          (click)="sendRequestSame()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
      </footer>
    </div>
    <div class="modal-observation" [ngClass]="{ open: commentsEnable }">
      <div class="ion-padding container-flex">
        <button class="bt-close">
          <ion-icon
            name="close-circle"
            (click)="
              commentsEnable = false; formReserv.get('comentario').setValue('')
            "
          ></ion-icon>
        </button>

        <div class="header">
          <h2 class="title">
            <ion-icon name="chatbubbles"></ion-icon> Add a comment <br />
            to this reservation
          </h2>
        </div>

        <div class="container-textarea">
          <textarea
            formControlName="observation"
            class="textarea-default"
            placeholder="Insert your comment..."
          ></textarea>
        </div>

        <button
          (click)="commentsEnable = false"
          class="ion-margin-top button-bigger animation-none"
          expand="full"
        >
          OK
        </button>
      </div>
    </div>
  </form>

  <div>
    <div
      class="calendar-scheduled-box"
      [ngClass]="{ opened: openedCalendar }"
      *ngIf="sameRestaurant"
    >
      <div class="box">
        <h5>Select the day of the week</h5>
        <ul class="days-week-list">
          <li
            *ngFor="let dayweek of daysweek; let i = index"
            (click)="selectedDayWeek(i, formReserv.get('restaurante').value)"
            [ngClass]="{ selected: dayweek == selectedweek }"
          >
            <h5>{{ dayweek.label.substring(0, 3) }}</h5>
            <strong class="day">{{ dayweek.dateNumber }}</strong>
          </li>
        </ul>
      </div>
      <div class="box" *ngIf="hoursoperation.length">
        <h5>Select time</h5>
        <ul class="days-timer-list">
          <li
            *ngFor="let hour of hoursoperation; let i = index"
            (click)="selectHour(i)"
            [ngClass]="{ selected: hour == selectedhour }"
          >
            <strong>{{ hour.horarioConvertido }}</strong>
          </li>
        </ul>
      </div>
      <div class="text-center" *ngIf="hoursoperation.length <= 1">
        <p>No hours available</p>
      </div>
      <footer class="footer">
        <ion-button [disabled]="!selectedhour" (click)="setHourCalendar()"
          >Confirm</ion-button
        >
        <ion-button (click)="openedCalendar = false" color="danger"
          >Cancel</ion-button
        >
      </footer>
    </div>
  </div>

  <form class="form" [formGroup]="formReserv" *ngIf="!sameRestaurant">
    <div>
      <app-kitchen-types
        #kitchen
        *ngIf="
          (claim === userType.Caller || claim === userType.Passenger) &&
          !selectedRestaurantDashboard
        "
        (emitterKitchenSelected)="eventKitchenSelected($event)"
      ></app-kitchen-types>
      <ion-modal #modal class="establishment-modal">
        <ng-template>
          <ion-content>
            <ion-toolbar>
              <ion-buttons slot="end" (click)="closeModal()">
                <ion-button color="primary"
                  ><ion-icon name="close-circle"></ion-icon
                ></ion-button>
              </ion-buttons>
            </ion-toolbar>
            <ion-grid
              style="background-color: white"
              class="service-container"
              *ngIf="
                this.selectedKitchen &&
                ((restaurants.length && claim === userType.Caller) ||
                  claim === userType.Passenger)
              "
            >
              <ion-label>Select a Service</ion-label>
              <ion-row
                *ngIf="!selectedRestaurantDashboard"
                style="justify-content: center"
              >
                <ion-col *ngFor="let restaurant of restaurants" size="6">
                  <ion-card
                    class="card"
                    style="background-color: white; text-align: -webkit-center"
                    [ngClass]="{
                      selected:
                        chosenRestaurant &&
                        restaurant &&
                        chosenRestaurant?.id === restaurant.id,
                    }"
                    (click)="selectedRestaurant(restaurant, true)"
                  >
                    <ion-card-header>
                      <ion-card-title style="font-size: smaller">{{
                        restaurant.nomeRestaurante
                      }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                      <ion-img
                        [src]="restaurant.icone"
                        style="width: 70%"
                        class="icon"
                      />
                      <small>{{ restaurant.preco }}</small>
                      <!-- <small>{{ restaurant.endereco }}</small> -->
                    </ion-card-content>
                  </ion-card>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-card *ngIf="chosenRestaurant" class="establishment-card">
                  <ion-label>Selected Service</ion-label>
                  <ion-card-header class="establishment-header">
                    <ion-img
                      [src]="chosenRestaurant.icone"
                      class="establishment-img"
                    ></ion-img>
                    <ion-card-title class="title">
                      {{ chosenRestaurant.nomeRestaurante }}</ion-card-title
                    >
                    <ion-card-subtitle
                      class="subtitle"
                      *ngIf="chosenRestaurant.tipoCozinha"
                      >{{
                        chosenRestaurant.tipoCozinha.nome
                      }}</ion-card-subtitle
                    >
                    <ion-card-subtitle class="subtitle">{{
                      chosenRestaurant.tipoEstabelecimento
                    }}</ion-card-subtitle>
                    <ion-card-subtitle class="subtitle">{{
                      chosenRestaurant.endereco
                    }}</ion-card-subtitle>
                    <ion-card-subtitle class="subtitle">{{
                      chosenRestaurant.telefone
                    }}</ion-card-subtitle>
                  </ion-card-header>
                  <ion-card-content class="establishment-card-content">
                    <span class="price">{{ chosenRestaurant.preco }}</span>
                    <div class="chips">
                      <ion-chip
                        *ngFor="let servico of chosenRestaurant.servicos"
                      >
                        <small>{{ getServiceDescription(servico) }}</small>
                      </ion-chip>
                    </div>
                    <div class="flags" #row>
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.English)
                        "
                        src="assets/English.svg"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(
                            Languages.Portuguese
                          )
                        "
                        src="assets/Portuguese.svg"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.Spanish)
                        "
                        src="assets/Spanish.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.Mandarin)
                        "
                        src="assets/Mandarin.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.French)
                        "
                        src="assets/French.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.Italian)
                        "
                        src="assets/Italian.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.Japanese)
                        "
                        src="assets/Japanese.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.Arabic)
                        "
                        src="assets/Arabic.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.German)
                        "
                        src="assets/German.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(Languages.Russian)
                        "
                        src="assets/Russian.png"
                        class="ico"
                        alt=""
                      />
                      <ion-img
                        *ngIf="
                          chosenRestaurant.idiomas?.includes(
                            Languages.Vietnamese
                          )
                        "
                        src="assets/Vietnamese.png"
                        class="ico"
                        alt=""
                      />
                    </div>
                    <div
                      class="value-payment"
                      *ngIf="
                        formReserv.get('valor').value > 0 &&
                        claim === userType.Caller &&
                        chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
                      "
                    >
                      <p>Amount payable:</p>
                      <h2 class="value">
                        {{ formReserv.get("valor").value | currency }}
                      </h2>
                    </div>
                    <div
                      class="value-payment"
                      *ngIf="
                        claim === userType.Caller &&
                        chosenRestaurant?.tipoEstabelecimento == 'BROCHURE'
                      "
                    >
                      <p>Points:</p>
                      <h2 class="value">{{ chosenRestaurant?.pontuacao }}</h2>
                    </div>
                  </ion-card-content>
                </ion-card>
              </ion-row>
              <ion-row *ngIf="chosenRestaurant">
                <ion-col width-50>
                  <ion-item>
                    <ion-label position="floating">Client</ion-label>
                    <ion-input
                      type="text"
                      formControlName="nome"
                      [attr.readonly]="
                        this.sameRestaurant ||
                        (claim === userType.Passenger && !isQrCode)
                      "
                    ></ion-input>
                  </ion-item>
                </ion-col>
                <ion-col width-50>
                  <ion-item>
                    <ion-label position="floating">Cell Phone</ion-label>
                    <ion-input
                      type="tel"
                      formControlName="celular"
                      [attr.readonly]="
                        this.sameRestaurant ||
                        (claim === userType.Passenger && !isQrCode)
                      "
                    ></ion-input>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row
                *ngIf="
                  (claim === userType.Caller || claim === userType.Passenger) &&
                  chosenRestaurant &&
                  chosenRestaurant?.tipoEstabelecimento !== 'BROCHURE'
                "
              >
                <ion-col width-33>
                  <ion-item>
                    <ion-label position="floating">Language</ion-label>
                    <ion-select
                      [value]="language"
                      multiple
                      formControlName="idiomas"
                    >
                      <ion-select-option
                        *ngFor="let language of languagesAvailable()"
                        [value]="language.value"
                        [disabled]="checkValue(language)"
                      >
                        {{ language.label }}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
                <ion-col
                  width-33
                  *ngIf="
                    chosenRestaurant &&
                    chosenRestaurant.tipoComissao &&
                    chosenRestaurant.tipoComissao != 'COMISSAO_FIXA'
                  "
                >
                  <ion-item>
                    <ion-label position="floating">N° People</ion-label>
                    <ion-input
                      (change)="calculateValue()"
                      formControlName="quantidade-pessoas"
                      type="number"
                      max="30"
                      min="0"
                    >
                    </ion-input>
                  </ion-item>
                </ion-col>
                <ion-col width-33>
                  <ion-item>
                    <ion-label position="floating">Service</ion-label>
                    <ion-select
                      [value]="service"
                      multiple
                      formControlName="servicos"
                      placeholder="Select a service"
                    >
                      <ion-select-option
                        *ngFor="let service of servicesAvailable()"
                        [value]="service.value"
                      >
                        {{ service.label }}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
              </ion-row>
              <div
                class="block-check"
                *ngIf="
                  claim != userType.Restaurant &&
                  chosenRestaurant?.aceitaReservasTipoWalkin &&
                  chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
                "
              >
                <ion-label
                  *ngIf="
                    chosenRestaurant?.aceitaReservasTipoWalkin &&
                    !chosenRestaurant?.aceitaReservasAgendadas
                  "
                >
                  Note: Walk-ins only</ion-label
                >
                <ion-checkbox
                  slot="end"
                  (ionChange)="setWalkIn()"
                  formControlName="walkIn"
                ></ion-checkbox>
                <ion-label><strong>Walk-in</strong></ion-label>
              </div>
              <ion-row
                *ngIf="
                  claim === userType.Restaurant &&
                  chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
                "
              >
                <ion-col>
                  <ion-item>
                    <ion-label position="floating">N° People</ion-label>
                    <ion-input
                      (change)="calculateValue()"
                      formControlName="quantidade-pessoas"
                      type="number"
                      max="30"
                      min="0"
                    >
                    </ion-input>
                  </ion-item>
                </ion-col>
                <ion-col *ngIf="chosenRestaurant?.aceitaReservasTipoWalkin">
                  <div class="block-check block-check2">
                    <ion-label
                      *ngIf="chosenRestaurant?.aceitaReservasTipoWalkin"
                      >Note: Walk-ins only</ion-label
                    >
                    <ion-checkbox
                      slot="end"
                      (ionChange)="setWalkIn()"
                      formControlName="walkIn"
                    ></ion-checkbox>
                    <ion-label><strong>Walk-in</strong></ion-label>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row
                *ngIf="
                  !walkIn && chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
                "
              >
                <ion-col width-100>
                  <div
                    class="calendar"
                    *ngIf="
                      formReserv.get('restaurante').value &&
                      chosenRestaurant?.aceitaReservasAgendadas
                    "
                  >
                    <ion-label>Reservation Date</ion-label>
                    <div class="datepicker-form">
                      <p (click)="openCalendarScheduled()">
                        {{
                          selectedDate
                            ? (dateControl.value
                              | date
                                : "yyyy/MM/dd
                        hh:mm a")
                            : "Select a date"
                        }}
                      </p>
                      <ion-label
                        position="floating"
                        style="margin-bottom: 10px; margin-left: 5px"
                      >
                        <ion-icon name="calendar-outline"></ion-icon>
                      </ion-label>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
              <!-- <ion-button
                [disabled]="disableBook || formReserv.invalid"
                class="ion-margin-top"
                color="primary"
                (click)="scroll(footer)"
                expand="full"
                shape="round"
                >Confirm
              </ion-button> -->
              <ion-button
                *ngIf="claim === userType.Passenger"
                (click)="sendRequestClient()"
                [disabled]="disableBook || formReserv.invalid"
                class="ion-margin-top"
                color="primary"
                expand="full"
                shape="round"
                >Book
              </ion-button>
              <ion-button
                *ngIf="claim === userType.Caller"
                (click)="sendRequest(true)"
                [disabled]="disableBook || formReserv.invalid"
                class="ion-margin-top"
                color="primary"
                expand="full"
                shape="round"
                >Book
              </ion-button>
            </ion-grid>
            <div
              class="calendar-scheduled-box"
              [ngClass]="{ opened: openedCalendar }"
            >
              <div class="box">
                <h5>Select the day of the week</h5>
                <ul class="days-week-list">
                  <li
                    *ngFor="let dayweek of daysweek; let i = index"
                    (click)="
                      selectedDayWeek(i, formReserv.get('restaurante').value)
                    "
                    [ngClass]="{ selected: dayweek == selectedweek }"
                  >
                    <h5>{{ dayweek.label.substring(0, 3) }}</h5>
                    <strong class="day">{{ dayweek.dateNumber }}</strong>
                  </li>
                </ul>
              </div>
              <div class="box" *ngIf="hoursoperation.length">
                <h5>Select time</h5>
                <ul class="days-timer-list">
                  <li
                    *ngFor="let hour of hoursoperation; let i = index"
                    (click)="selectHour(i)"
                    [ngClass]="{ selected: hour == selectedhour }"
                  >
                    <strong>{{ hour.horarioConvertido }}</strong>
                  </li>
                </ul>
              </div>
              <div class="text-center" *ngIf="hoursoperation.length <= 1">
                <p>No hours available</p>
              </div>
              <footer class="footer">
                <ion-button
                  [disabled]="!selectedhour"
                  (click)="setHourCalendar()"
                  >Confirm</ion-button
                >
                <ion-button (click)="openedCalendar = false" color="danger"
                  >Cancel</ion-button
                >
              </footer>
            </div>
          </ion-content>
        </ng-template>
      </ion-modal>

      <!-- <div
        class="value-payment"
        *ngIf="
          formReserv.get('valor').value > 0 &&
          claim === userType.Caller &&
          chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
        "
      >
        <p>Amount payable:</p>
        <h2 class="value">{{ formReserv.get("valor").value | currency }}</h2>
      </div>
      <div
        class="value-payment"
        *ngIf="
          claim === userType.Caller &&
          chosenRestaurant?.tipoEstabelecimento == 'BROCHURE'
        "
      >
        <p>Points:</p>
        <h2 class="value">{{ chosenRestaurant?.pontuacao }}</h2>
      </div> -->
      <div class="comment-box" *ngIf="formReserv.get('observation').value">
        <ion-label position="floating">Comment</ion-label>
        <div class="block">
          <ion-icon name="chatbubbles"></ion-icon>
          {{ formReserv.get("observation").value }}
        </div>
      </div>
      <footer class="ion-padding-top ion-padding-bottom" #footer>
        <!-- <ion-button
          *ngIf="claim === userType.Caller"
          (click)="sendRequest()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
        <ion-button
          *ngIf="claim === userType.Passenger"
          (click)="sendRequestClient()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button> -->
        <ion-button
          *ngIf="claim === userType.Restaurant"
          (click)="sendRequestSame()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
      </footer>
    </div>
    <div class="modal-observation" [ngClass]="{ open: commentsEnable }">
      <div class="ion-padding container-flex">
        <button class="bt-close">
          <ion-icon
            name="close-circle"
            (click)="
              commentsEnable = false; formReserv.get('comentario').setValue('')
            "
          ></ion-icon>
        </button>

        <div class="header">
          <h2 class="title">
            <ion-icon name="chatbubbles"></ion-icon> Add a comment <br />
            to this reservation
          </h2>
        </div>

        <div class="container-textarea">
          <textarea
            formControlName="observation"
            class="textarea-default"
            placeholder="Insert your comment..."
          ></textarea>
        </div>

        <button
          (click)="commentsEnable = false"
          class="ion-margin-top button-bigger animation-none"
          expand="full"
        >
          OK
        </button>
      </div>
    </div>
  </form>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed" style="z-index: 9">
    <ion-fab-button color="dark" (click)="openComment()">
      <ion-icon name="chatbox"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <app-modal-component
    *ngIf="isOpenDetailBooking"
    (stateOpen)="isOpenDetailBooking = $event"
  >
    <ion-img src="assets/images/logo-app-gs.png" class="brand-footer" alt="" />

    <div class="information-booking text-center" #reservationInfo>
      <ion-icon name="checkmark-circle" class="ico"></ion-icon>
      <p class="title">{{ getTitle() }}</p>
      <h2>{{ getConfirmationText() }}</h2>
      <p style="font-size: 11px">{{ getNote() }}</p>
      <div class="container">
        <div
          class="line"
          *ngIf="claim === userType.Caller || claim === userType.Passenger"
        >
          <p>
            <ion-icon name="restaurant"></ion-icon>
            {{ dataBooking.restaurant.nomeRestaurante }}
            <strong class="price">{{ dataBooking.restaurant.preco }}</strong>
          </p>
          <p>
            <ion-icon name="call"></ion-icon>
            {{ dataBooking.restaurant.telefone }}
          </p>
          <p>
            <ion-icon name="business"></ion-icon>
            {{ dataBooking.restaurant.endereco }}
          </p>
        </div>
        <div class="line">
          <p><ion-icon name="person"></ion-icon> {{ dataBooking.nome }}</p>
          <p>
            <ion-icon name="time"></ion-icon>
            {{
              dataBooking["data-escolhida"]
                ? (dataBooking["data-escolhida"] | date: "short")
                : "Walk-in"
            }}
          </p>
          <p>
            <ion-icon name="people"></ion-icon>
            {{ dataBooking["quantidade-pessoas"] }}
            {{ dataBooking["quantidade-pessoas"] === 1 ? "person" : "people" }}
          </p>
          <p *ngIf="textDesconto">
            <ion-icon name="logo-usd"></ion-icon>
            <span>{{ textDesconto }}</span>
          </p>
        </div>
        <div class="row" style="padding: 10px">
          <div>
            <qrcode
              [qrdata]="qrCodeUrl"
              [width]="128"
              [errorCorrectionLevel]="'H'"
            ></qrcode>
          </div>
        </div>
      </div>
      <!-- <ion-button *ngIf="!isPwa" class="ion-margin-top" color="secondary" expand="full"
        (click)="shareReserv()">Share</ion-button> -->
      <ion-button
        *ngIf="isSharing"
        class="ion-margin-top"
        color="light"
        expand="full"
        >Sharing, please wait...</ion-button
      >
      <ion-button
        *ngIf="!isSharing"
        class="ion-margin-top"
        color="success"
        expand="full"
        (click)="shareReserv()"
        >Share</ion-button
      >
      <ion-button
        *ngIf="!isSharing"
        class="ion-margin-top"
        color="light"
        expand="full"
        (click)="gotoHome()"
        >Go To Home</ion-button
      >
    </div>
  </app-modal-component>
</ion-content>

<!-- Dashboard map reservation below -->

<div *ngIf="!showHeader">
  <form class="form" [formGroup]="formReserv">
    <ion-grid>
      <ion-row>
        <ion-col width-50>
          <ion-item>
            <ion-label position="floating">Client</ion-label>
            <ion-input
              type="text"
              formControlName="nome"
              [attr.readonly]="
                this.sameRestaurant ||
                (claim === userType.Passenger && !isQrCode)
              "
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col width-50>
          <ion-item>
            <ion-label position="floating">Cell Phone</ion-label>
            <ion-input
              type="tel"
              formControlName="celular"
              [attr.readonly]="
                this.sameRestaurant ||
                (claim === userType.Passenger && !isQrCode)
              "
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div>
      <app-kitchen-types
        #kitchen
        *ngIf="
          (claim === userType.Caller || claim === userType.Passenger) &&
          !selectedRestaurantDashboard
        "
        (emitterKitchenSelected)="eventKitchenSelected($event)"
      ></app-kitchen-types>
      <ion-grid>
        <ion-row *ngIf="!selectedRestaurantDashboard">
          <ion-col
            sizeLg="4"
            sizeMd="4"
            sizeXs="4"
            *ngFor="let restaurant of restaurants"
          >
            <ion-card
              class="card"
              style="background-color: white; text-align: -webkit-center"
              [ngClass]="{
                selected:
                  chosenRestaurant &&
                  restaurant &&
                  chosenRestaurant?.id === restaurant.id,
              }"
              (click)="selectedRestaurant(restaurant)"
            >
              <ion-card-header>
                <ion-card-title style="font-size: smaller">{{
                  restaurant.nomeRestaurante
                }}</ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ion-img
                  [src]="restaurant.icone"
                  style="width: 70%"
                  class="icon"
                />
                <small>{{ restaurant.preco }}</small>
                <small>{{ restaurant.endereco }}</small>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="
            (claim === userType.Caller || claim === userType.Passenger) &&
            chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
          "
        >
          <ion-col width-33>
            <ion-item>
              <ion-label position="floating">Languagex</ion-label>
              <ion-select [value]="language" multiple formControlName="idiomas">
                <ion-select-option
                  *ngFor="let language of languagesAvailable()"
                  [value]="language.value"
                  [disabled]="checkValue(language)"
                >
                  {{ language.label }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col
            width-33
            *ngIf="
              chosenRestaurant &&
              chosenRestaurant.tipoComissao &&
              chosenRestaurant.tipoComissao != 'COMISSAO_FIXA'
            "
          >
            <ion-item>
              <ion-label position="floating">N° People</ion-label>
              <ion-input
                (change)="calculateValue()"
                formControlName="quantidade-pessoas"
                type="number"
                max="30"
                min="0"
              >
              </ion-input>
            </ion-item>
          </ion-col>
          <ion-col width-33>
            <ion-item>
              <ion-label position="floating">Service</ion-label>
              <ion-select
                [value]="service"
                multiple
                formControlName="servicos"
                placeholder="Select a service"
              >
                <ion-select-option
                  *ngFor="let service of servicesAvailable()"
                  [value]="service.value"
                >
                  {{ service.label }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>
        <div
          class="block-check"
          *ngIf="
            claim != userType.Restaurant &&
            chosenRestaurant?.aceitaReservasTipoWalkin &&
            chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
          "
        >
          <ion-label
            *ngIf="
              chosenRestaurant?.aceitaReservasTipoWalkin &&
              !chosenRestaurant?.aceitaReservasAgendadas
            "
          >
            Note: Walk-ins only</ion-label
          >
          <ion-checkbox
            slot="end"
            (ionChange)="setWalkIn()"
            formControlName="walkIn"
          ></ion-checkbox>
          <ion-label><strong>Walk-in</strong></ion-label>
        </div>
        <ion-row
          *ngIf="
            claim === userType.Restaurant &&
            chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
          "
        >
          <ion-col>
            <ion-item>
              <ion-label position="floating">N° People</ion-label>
              <ion-input
                (change)="calculateValue()"
                formControlName="quantidade-pessoas"
                type="number"
                max="30"
                min="0"
              >
              </ion-input>
            </ion-item>
          </ion-col>
          <ion-col *ngIf="chosenRestaurant?.aceitaReservasTipoWalkin">
            <div class="block-check block-check2">
              <ion-label *ngIf="chosenRestaurant?.aceitaReservasTipoWalkin"
                >Note: Walk-ins only</ion-label
              >
              <ion-checkbox
                slot="end"
                (ionChange)="setWalkIn()"
                formControlName="walkIn"
              ></ion-checkbox>
              <ion-label><strong>Walk-in</strong></ion-label>
            </div>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="!walkIn && chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'"
        >
          <ion-col width-100>
            <div
              class="calendar"
              *ngIf="
                formReserv.get('restaurante').value &&
                chosenRestaurant?.aceitaReservasAgendadas
              "
            >
              <ion-label>Reservation Date</ion-label>
              <div class="datepicker-form">
                <p (click)="openCalendarScheduled()">
                  {{
                    selectedDate
                      ? (dateControl.value | date: "yyyy/MM/dd hh:mm a")
                      : "Select a date"
                  }}
                </p>
                <ion-label
                  position="floating"
                  style="margin-bottom: 10px; margin-left: 5px"
                >
                  <ion-icon name="calendar-outline"></ion-icon>
                </ion-label>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div
        class="value-payment"
        *ngIf="
          formReserv.get('valor').value > 0 &&
          claim === userType.Caller &&
          chosenRestaurant?.tipoEstabelecimento != 'BROCHURE'
        "
      >
        <p>Amount payable:</p>
        <h2 class="value">{{ formReserv.get("valor").value | currency }}</h2>
      </div>
      <div
        class="value-payment"
        *ngIf="
          claim === userType.Caller &&
          chosenRestaurant?.tipoEstabelecimento == 'BROCHURE'
        "
      >
        <p>Points:</p>
        <h2 class="value">{{ chosenRestaurant?.pontuacao }}</h2>
      </div>
      <div class="comment-box" *ngIf="formReserv.get('observation').value">
        <ion-label position="floating">Comment</ion-label>
        <div class="block">
          <ion-icon name="chatbubbles"></ion-icon>
          {{ formReserv.get("observation").value }}
        </div>
      </div>
      <footer class="ion-padding-top ion-padding-bottom" #footer>
        <ion-button
          *ngIf="claim === userType.Caller"
          (click)="sendRequest()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
        <ion-button
          *ngIf="claim === userType.Passenger"
          (click)="sendRequestClient()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
        <ion-button
          *ngIf="claim === userType.Restaurant"
          (click)="sendRequestSame()"
          [disabled]="disableBook || formReserv.invalid"
          class="ion-margin-top"
          color="primary"
          expand="full"
          shape="round"
          >Book
        </ion-button>
      </footer>
    </div>
    <div class="modal-observation" [ngClass]="{ open: commentsEnable }">
      <div class="ion-padding container-flex">
        <button class="bt-close">
          <ion-icon
            name="close-circle"
            (click)="
              commentsEnable = false; formReserv.get('comentario').setValue('')
            "
          ></ion-icon>
        </button>

        <div class="header">
          <h2 class="title">
            <ion-icon name="chatbubbles"></ion-icon> Add a comment <br />
            to this reservation
          </h2>
        </div>

        <div class="container-textarea">
          <textarea
            formControlName="observation"
            class="textarea-default"
            placeholder="Insert your comment..."
          ></textarea>
        </div>

        <button
          (click)="commentsEnable = false"
          class="ion-margin-top button-bigger animation-none"
          expand="full"
        >
          OK
        </button>
      </div>
    </div>
  </form>
  <ion-fab
    vertical="bottom"
    horizontal="end"
    slot="fixed"
    style="z-index: 9; bottom: 50px !important"
  >
    <ion-fab-button color="dark" (click)="openComment()">
      <ion-icon name="chatbox"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <app-modal-component
    *ngIf="isOpenDetailBooking"
    (stateOpen)="isOpenDetailBooking = $event"
  >
    <ion-img src="assets/images/logo-app-gs.png" class="brand-footer" alt="" />

    <div class="information-booking text-center" #reservationInfo>
      <ion-icon name="checkmark-circle" class="ico"></ion-icon>
      <p class="title">{{ getTitle() }}</p>
      <h2>{{ getConfirmationText() }}</h2>
      <p style="font-size: 11px">{{ getNote() }}</p>
      <div class="container">
        <div
          class="line"
          *ngIf="claim === userType.Caller || claim === userType.Passenger"
        >
          <p>
            <ion-icon name="restaurant"></ion-icon>
            {{ dataBooking.restaurant.nomeRestaurante }}
            <strong class="price">{{ dataBooking.restaurant.preco }}</strong>
          </p>
          <p>
            <ion-icon name="call"></ion-icon>
            {{ dataBooking.restaurant.telefone }}
          </p>
          <p>
            <ion-icon name="business"></ion-icon>
            {{ dataBooking.restaurant.endereco }}
          </p>
        </div>
        <div class="line">
          <p><ion-icon name="person"></ion-icon> {{ dataBooking.nome }}</p>
          <p>
            <ion-icon name="time"></ion-icon>
            {{
              dataBooking["data-escolhida"]
                ? (dataBooking["data-escolhida"] | date: "short")
                : "Walk-in"
            }}
          </p>
          <p>
            <ion-icon name="people"></ion-icon>
            {{ dataBooking["quantidade-pessoas"] }}
            {{ dataBooking["quantidade-pessoas"] === 1 ? "person" : "people" }}
          </p>
          <p *ngIf="textDesconto">
            <ion-icon name="logo-usd"></ion-icon>
            <span>{{ textDesconto }}</span>
          </p>
        </div>
        <div class="row" style="padding: 10px">
          <div>
            <qrcode
              [qrdata]="qrCodeUrl"
              [width]="128"
              [errorCorrectionLevel]="'H'"
            ></qrcode>
          </div>
        </div>
      </div>
      <ion-button
        *ngIf="!isPwa"
        class="ion-margin-top"
        color="secondary"
        expand="full"
        (click)="shareReserv()"
        >Share</ion-button
      >
      <ion-button
        class="ion-margin-top"
        color="grey"
        expand="full"
        (click)="gotoHome()"
        >Go To Home</ion-button
      >
    </div>
  </app-modal-component>
  <div
    class="calendar-scheduled-box dashboard"
    [ngClass]="{ opened: openedCalendar }"
  >
    <div class="box">
      <h5>Select the day of the week</h5>
      <ul class="days-week-list">
        <li
          *ngFor="let dayweek of daysweek; let i = index"
          (click)="selectedDayWeek(i, formReserv.get('restaurante').value)"
          [ngClass]="{ selected: dayweek == selectedweek }"
        >
          <h5>{{ dayweek.label.substring(0, 3) }}</h5>
          <strong class="day">{{ dayweek.dateNumber }}</strong>
        </li>
      </ul>
    </div>
    <div class="box" *ngIf="hoursoperation.length">
      <h5>Select time</h5>
      <ul class="days-timer-list">
        <li
          *ngFor="let hour of hoursoperation; let i = index"
          (click)="selectHour(i)"
          [ngClass]="{ selected: hour == selectedhour }"
        >
          <strong>{{ hour.horarioConvertido }}</strong>
        </li>
      </ul>
    </div>
    <div class="text-center" *ngIf="hoursoperation.length <= 1">
      <p>No hours available</p>
    </div>
    <footer class="footer">
      <ion-button [disabled]="!selectedhour" (click)="setHourCalendar()"
        >Confirm</ion-button
      >
      <ion-button (click)="openedCalendar = false" color="danger"
        >Cancel</ion-button
      >
    </footer>
  </div>
</div>
